import React from 'react';

export interface Task {
  id: string;
  title: string;
  description: string;
  label?: string;
  dueDate?: string; // ISO yyyy-MM-dd
  color?: string;
  priority?: 'low' | 'medium' | 'high';
}

interface Props {
  task: Task;
  onClick?: () => void;
}

const TaskCard: React.FC<Props> = ({ task, onClick }) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 cursor-pointer flex gap-3 hover:shadow-md transition-all duration-200" onClick={onClick}>
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center text-sm font-bold shadow-sm" style={{border:`2px solid ${task.color || '#6366f1'}`}}>
        {task.title.charAt(0).toUpperCase()}
      </div>
      <div className="flex-1">
        <h4 className="font-semibold text-gray-800 mb-2 line-clamp-1 text-sm">{task.title}</h4>
        {task.description && <p className="text-gray-600 text-xs line-clamp-2 mb-3 leading-relaxed">{task.description}</p>}
        <div className="flex justify-between items-center">
          {task.label && <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full font-medium">{task.label}</span>}
          {task.priority && <span className={`px-3 py-1 rounded-full text-xs font-semibold ${priorityClass(task.priority)}`}>{task.priority}</span>}
        </div>
      </div>
    </div>
  );
};

function priorityClass(p: string){
  switch(p){
    case 'low': return 'bg-green-100 text-green-700';
    case 'high': return 'bg-red-100 text-red-700';
    default: return 'bg-yellow-100 text-yellow-700';
  }
}

export default TaskCard; 